module.exports = __webpack_public_path__ + "static/media/business-with-purpose.d37e60b5.jpg";